import { useEffect, useRef, useState } from "react";

/**
 * Anima un número de 0 hasta `target` cuando `start` se vuelve true.
 * Usa easeOutCubic para una sensación natural.
 */
export function useCountUp(target: number, start: boolean, duration = 1300) {
    const [value, setValue] = useState(0);
    const startedRef = useRef(false);

    useEffect(() => {
        if (!start || startedRef.current) return;
        startedRef.current = true;

        let raf = 0;
        const t0 = performance.now();
        const tick = (now: number) => {
            const p = Math.min(1, (now - t0) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setValue(Math.round(target * eased));
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [start, target, duration]);

    return value;
}
